import React from "react";
import { Button, Flex, Text } from "@mantine/core";
import useAppStore from "./report-recipe-runner-store";
import { shallow } from "zustand/shallow";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const formatter = new Intl.ListFormat("en", {
  style: "long",
  type: "conjunction",
});

export default function SavedRecipeMeta() {
  const { locations, orgs, reset, savedRecipe } = useAppStore(
    (state) => ({
      locations: state.locations,
      orgs: state.orgs,
      reset: state.reset,
      savedRecipe: state.saved_recipe,
    }),
    shallow
  );

  const queryClient = useQueryClient();

  return (
    <>
      <Text fw={600}>{savedRecipe.title} (saved recipe)</Text>
      {savedRecipe.description && (
        <Text mb="xs" w={"65%"}>
          {savedRecipe.description}
        </Text>
      )}
      {savedRecipe.query_data && (
        <>
          {locations && locations.length > 0 && (
            <Text>
              <b>Locations:</b> {formatter.format(locations.map((m) => m.name))}
            </Text>
          )}
          {orgs && orgs.length > 0 && (
            <Text>
              <b>Organizations:</b> {formatter.format(orgs.map((m) => m.name))}
            </Text>
          )}
        </>
      )}
      <Button
        size="xs"
        variant="subtle"
        color="gray"
        style={{ width: "fit-content" }}
        p={0}
        onClick={() => {
          reset().then(() => {
            queryClient.invalidateQueries([`snapshots`]);
          });
        }}
      >
        exit saved recipe
      </Button>
    </>
  );
}
